import { Listbox_Option_default } from "./chunk-NWTCAASI.js";
import { Listbox_default } from "./chunk-5XGGEX4T.js";

// src/elements/Listbox/index.ts
var ListboxComponent = Listbox_default;
ListboxComponent.Option = Listbox_Option_default;
ListboxComponent.Option.displayName = "Listbox.Option";
export { ListboxComponent };